export default "__VITE_ASSET__DJISS00E__"